module.exports = __webpack_public_path__ + "static/Golem_Iron-31d9c5f702a006f505e20ad99413786a.jpg";